import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';

import { Group } from '../../models/Group';

import { getColor } from './UICommon';
import { CardAvatar } from '../styledComponent/CardAvatar.style';
import { PurpleButton } from '../styledComponent/Buttons.style';

interface StyleProps {
  isCarousel: boolean;
}

const CardRoot = styled.div`
  border-radius: 24px;
  border: 1px solid ${getColor('PURPLE_100')};
  min-height: 208px;
  padding: 32px;
  background-color: #faf5ff;
  color: ${getColor('BLACK_80')};
  font-weight: 400;
  line-height: 20px;
  font-size: 14px;
  width: 311px;
  @media (max-width: 600px) {
    margin-right: ${(props: StyleProps) => (props.isCarousel ? '12px' : 0)};
  }
`;

const CardHeader = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;

const GfName = styled.h4`
  color: #6b65e7;
  font-weight: 600;
  max-width: 190px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const GroupTitle = styled.h4`
  font-weight: 600;
  color: ${getColor('BLACK')};
  font-size: 18px;
  margin-bottom: 4px;
`;

const P = styled.p`
  font-size: 16px;
  line-height: 24px;
`;

const DivButton = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin-top: 32px;
`;

export interface GroupCardProps {
  buttonText?: string;
  isCarousel: boolean;
  group: Group;
  onClick?: (id: string) => void;
  stepName: string;
  isButtonDisabled: boolean;
  // identify element for e2e test
  id: string;
}

export const GroupCard = ({
  group,
  buttonText,
  isCarousel = false,
  onClick,
  stepName,
  isButtonDisabled,
  id,
}: GroupCardProps) => {
  const date = moment(group.schedule);

  return (
    <CardRoot isCarousel={isCarousel}>
      <CardHeader>
        <CardAvatar size={40} src={group.leaderImg} />
        <div>
          <GfName>{group.leaderName}</GfName>
          <p>{stepName === 'productInformation' ? 'Groups Facilitator' : `Starting ${date.format('MMM D')}`}</p>
        </div>
      </CardHeader>

      <GroupTitle>{group.title}</GroupTitle>
      <P>{`${date.format('dddd')} at ${date.format('h')}-${date.add(1, 'hours').format('h A')}`}</P>
      {buttonText ? (
        <DivButton>
          <PurpleButton
            id={id}
            onClick={() => {
              onClick ? onClick(group.id) : console.log('error');
            }}
            disabled={isButtonDisabled}
          >
            {buttonText}
          </PurpleButton>
        </DivButton>
      ) : (
        ''
      )}
    </CardRoot>
  );
};
